import { CLEAR_ALL } from '../types';

export const clearALLStates = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ALL,
    payload: '',
  });
};
